var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThanks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#0C9BED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5121 41.5394C68.5121 42.5019 68.4434 43.4415 68.3288 44.3352C67.2747 43.8769 66.1289 43.6248 64.9143 43.6248C62.1184 43.6248 59.6434 44.9769 58.108 47.0394C56.5497 44.9769 54.0747 43.6248 51.2788 43.6248C46.5809 43.6248 42.7768 47.4519 42.7768 52.1956C42.7768 58.3373 46.0309 63.0352 49.6518 66.2206C49.5372 66.2894 49.4226 66.3124 49.308 66.3582C48.6205 66.6103 47.4747 66.6103 46.7872 66.3582C40.8518 64.3186 27.583 55.8852 27.583 41.5394C27.583 35.2144 32.6705 30.104 38.9497 30.104C42.6851 30.104 45.9851 31.8915 48.0476 34.6644C50.133 31.8915 53.433 30.104 57.1455 30.104C63.4247 30.104 68.5121 35.2144 68.5121 41.5394Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4159 52.1958C73.4159 62.9208 63.493 69.2458 59.0472 70.7583C58.5201 70.9417 57.6722 70.9417 57.1451 70.7583C55.243 70.1167 52.3326 68.5812 49.6514 66.2208C46.0305 63.0354 42.7764 58.3375 42.7764 52.1958C42.7764 47.4521 46.5805 43.625 51.2784 43.625C54.0743 43.625 56.5493 44.9771 58.1076 47.0396C59.643 44.9771 62.118 43.625 64.9139 43.625C66.1285 43.625 67.2743 43.8771 68.3284 44.3354C71.3305 45.6646 73.4159 48.6666 73.4159 52.1958Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanks);
export default __webpack_public_path__ + "static/media/thanks.e2d50d4779677832681ca2a4a4c45224.svg";
export { ForwardRef as ReactComponent };